import { SendingAddressMap } from "src/views/AssetManagement/BatchContractSweep/contexts/PreviewContext";

export const isSweepAmountSelected = (
  sweepAmount: string,
  isPendingQueue: boolean,
) => (!!sweepAmount && sweepAmount !== "0") || isPendingQueue;

export const areAllAddressesSelected = (
  sendingAddressesMap: SendingAddressMap,
) =>
  Array.from(sendingAddressesMap.values()).every((info) =>
    isSweepAmountSelected(info.sweepAmount, info.isPendingQueue),
  );

export const setAllAddressesSelection = (
  previousMap: SendingAddressMap,
  isChecked: boolean,
) => {
  const nextMap = new Map(previousMap);

  nextMap.forEach((value, key) => {
    nextMap.set(key, {
      ...value,
      sweepAmount:
        isChecked || value.isPendingQueue
          ? value.sweepAmount === "0"
            ? value.sweepableAmount
            : value.sweepAmount
          : "0",
    });
  });

  return nextMap;
};

export const setSingleAddressSelection = (
  previousMap: SendingAddressMap,
  sendingAddress: string,
  isChecked: boolean,
) => {
  const currentAddressInfo = previousMap.get(sendingAddress);

  if (!currentAddressInfo || currentAddressInfo.isPendingQueue) {
    return previousMap;
  }

  return new Map(previousMap).set(sendingAddress, {
    ...currentAddressInfo,
    sweepAmount: isChecked ? currentAddressInfo.sweepableAmount : "0",
  });
};
